var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { id: "booking-verify" } },
    [
      _c("verify-tree-grid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "list",
            expression: "view==='list'"
          }
        ],
        ref: "verifyTreeGrid",
        attrs: {
          context: _vm.context,
          "use-order-center-mode": _vm.useOrderCenterMode,
          "order-center-branch": _vm.useOrderCenterBranch,
          "approve-cooperation-business": _vm.approveCooperationBusiness
        },
        on: {
          look: _vm.lookHandle,
          edit: _vm.editHandle,
          add: _vm.addHandle,
          copy: _vm.copyHandle,
          refresh: _vm.refreshHandle
        }
      }),
      _c("verify-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "verifyWorkspace",
        attrs: {
          "parent-context": _vm.context,
          "use-order-center-mode": _vm.useOrderCenterMode,
          "approve-cooperation-business": _vm.approveCooperationBusiness
        },
        on: {
          add: _vm.addHandle,
          copy: _vm.copyHandle,
          back: _vm.backToList,
          refresh: _vm.refreshHandle
        }
      }),
      _c("job-no-rule-selector", {
        ref: "jobNoRuleSelector",
        attrs: {
          visible: _vm.jobNoRule.visible,
          rules: _vm.jobNoRule.rules || []
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jobNoRule, "visible", $event)
          },
          selectedBack: function($event) {
            _vm.action === "add" ? _vm.doAddJob : _vm.doCopyJob
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }